import { type RootState } from "../../../store.ts"
import type { ColumnConfigItem, SurfaceKey, TabKey } from "./ui-preferences.types"

// Optional throughout: redux-persist's autoMergeLevel1 hard-sets the whole slice from
// the stored blob, so a blob written before these fields existed rehydrates without them.
export const selectSurfacePreference = <T>(
  state: RootState,
  key: SurfaceKey,
  fallback: T
): T => {
  const value = state.userUIPreferences.surfacePrefs?.[key]
  return value === undefined || value === null ? fallback : (value as T)
}

export const selectPrefsLoaded = (state: RootState): boolean =>
  state.userUIPreferences.loaded === true

export const selectTableTabColumns = (
  state: RootState,
  tableKey: string,
  tabKey: TabKey
): ColumnConfigItem[] | null =>
  state.userUIPreferences.prefs.tables?.[tableKey]?.[tabKey]?.columns ?? null
